// generated by genversion
export var version = '4.5.8';
//# sourceMappingURL=version.js.map